<template>
    <div class="mod mod-half mod-fbl">
        <h2><i>9</i>昨日涨停今日表现<span class="icon-help" v-on:click="toggle">?</span></h2>
        <div class="chart-legend">
            <span class="red">昨日涨停股今日表现:<b>{{legend.zrztbkzf}}%</b></span>
            <span class="blue">上证指数今日表现:<b>{{legend.szzszf}}%</b></span>
        </div>
        <div class="chart-wrap" id="zrztjrbx-echart-container"><p class="blank">-- 暂无数据 --</p></div>
        <p class="help-pop"  style="display: block" v-show="isHelp">昨日涨停（除新股次新股）今日表现是昨日封板资金的赚钱效应的延续，当延续的收益表现良好时，表名资金持续流入，市场走势趋于走强，反之则弱。</p>
    </div>
</template>

<script>
    import date from '@/utils/date.js'
    import { mapState } from 'vuex'
    export default {
        data:function(){
            return {
                isHelp:false,
                legend:{zrztbkzf:'--',szzszf:'--'},
                chartData:{time:[],szzszf:[],zrztbkzf:[]}
            }
        },
        computed: {
            ...mapState(['isBlankPage'])
            //this.BlankPage;
        },
        mounted:function(){
            this.getData();
        },
        methods: {
            toggle: function () {
                this.isHelp =! this.isHelp;
            },
            in_array:function (search,array){
                for(var i in array){
                    if(array[i]==search){
                        return true;
                    }
                }
                return false;
            },
            getData:function(){
                var _this=this;
                var Pro = Promise.all([_this.getQuoteMinZrztInfo(), _this.getQuoteMinSzzsInfo()]);
                Pro.then(function(data){
                    var zrzt,szzs,sd;
                    zrzt    = data[0][0];
                    szzs    = data[1][0];
                   // sd      = data[2];
                    if(zrzt.Data!=undefined){
                        for(var i = 0; i < zrzt.Data.length; i++){
                            var myDate     = new Date(zrzt.Data[i].ShiJian*1000);
                            var time       = date.formt(myDate,"hh:mm");
                            if(_this.in_array(time,['09:15','09:16','09:17','09:18','09:19','09:20','09:21','09:22','09:23','09:24','09:25','09:26','09:27','09:28','09:29','13:00'])){
                                continue;
                            }
                            _this.chartData.time.push(time);
                            _this.chartData.zrztbkzf.push((Math.round((zrzt.Data[i].ChengJiaoJia-zrzt.ZuoShou)/zrzt.ZuoShou* 10000) / 100.00).toFixed(2));
                        }
                        _this.legend.zrztbkzf      = _this.chartData.zrztbkzf[_this.chartData.zrztbkzf.length - 1];
                    }

                    if(szzs.Data!=undefined) {
                        for(var i = 0; i < szzs.Data.length; i++){
                            var myDate     = new Date(szzs.Data[i].ShiJian*1000);
                            var time       = date.formt(myDate,"hh:mm");
                            if(_this.in_array(time,['09:15','09:16','09:17','09:18','09:19','09:20','09:21','09:22','09:23','09:24','09:25','09:26','09:27','09:28','09:29','13:00'])){
                                continue;
                            }
                            _this.chartData.szzszf.push((Math.round((szzs.Data[i].ChengJiaoJia-szzs.ZuoShou)/szzs.ZuoShou* 10000) / 100.00).toFixed(2));
                        }
                        _this.legend.szzszf        = _this.chartData.szzszf[_this.chartData.szzszf.length - 1];
                    }
                    /*
                    for(var i=0;i<sd.length;i++){
                        if(sd[i].ZhongWenJianCheng == "" || sd[i].ZhongWenJianCheng == null || sd[i].ZhongWenJianCheng == undefined){
                            sd[i].ZhongWenJianCheng="--";
                        }
                        if(sd[i].ZhangFu == "" || sd[i].ZhangFu == null || sd[i].ZhangFu == undefined){
                            sd[i].ZhangFu = "--";
                        }
                    }
                    _this.ztgjrbx        = sd
                    */
                    if(!_this.isBlankPage && _this.chartData.time.length>0 && _this.chartData.szzszf.length>0 && _this.chartData.zrztbkzf.length>0){
                        _this.myChart();
                    }
                }).catch(err=>{
                        console.log(err);
                    })
            },
            //昨日涨停股
            getQuoteMinZrztInfo:function() {
                // return axios.get(yun_host+"/quote/min?obj=B$994247&token="+this.token)
                var _this=this;
                return new Promise(function (resolve, reject){
                    dzhyun.query('/quote/min', { obj:'B$994247'}, function(data) {
                        //...
                    }).then(function(data) {
                        //_this.handleGetQuoteMinZrztSucc(data);
                        resolve(data);
                    }).catch(function(err) {
                        //...
                    });
                }).catch(err=>{
                    console.log(err);
                });
            },
            //上证指数
            getQuoteMinSzzsInfo:function() {
                //return axios.get(yun_host+"/quote/min?obj=SH000001&token="+this.token)
                var _this=this;
                return new Promise(function (resolve, reject){
                   dzhyun.query('/quote/min', { obj:'SH000001'}, function(data) {
                        //...
                    }).then(function(data) {
                        //_this.handleGetQuoteMinSzzsSucc(data);
                        resolve(data);
                    }).catch(function(err) {
                        //...
                    });
                }).catch(err=>{
                    console.log(err);
                });
            },
            getStkdataInfo:function () {
               // var url        = yun_host+'/stkdata?gql=block=股票/大智慧自定义/指数板块/板块综合/昨日涨停&orderby=ZhangFu&desc=true&start=0&count=2&field=ZhongWenJianCheng,ZuiXinJia,ZhangFu&mode=2&token='+this.token;
                //return axios.get(url)
                var _this=this;
                return new Promise(function (resolve, reject){
                    dzhyun.query('/stkdata', { gql:'block=股票/大智慧自定义/指数板块/板块综合/昨日涨停',orderby:'ZhangFu',desc:true,start:'0',count:'2',field:'ZhongWenJianCheng,ZuiXinJia,ZhangFu',mode:'2'}, function(data) {
                    //...
                    }).then(function(data) {
                        //_this.handleGetStkdataSucc(data);
                        resolve(data);
                    }).catch(function(err) {
                        //...
                    });
                }).catch(err=>{
                    console.log(err);
                });
            },
            myChart:function(){
                var _this=this;
                // 基于准备好的dom，初始化echarts实例
                var echart = echarts.init(document.getElementById('zrztjrbx-echart-container'),'white');
                // 指定图表的配置项和数据
                var option = {
                    backgroundColor: '#FFFFFF',
                    title: {
                        show: true,
                        //text: '沪深涨跌停走势',
                        textStyle: {
                            color: '#222',
                            fontSize: 12,
                            fontWeight: 'normal'
                        },
                        z: 2,
                        left: 30,
                        top: '-5px'
                    },
                    tooltip: {
                        trigger: 'axis',
                        backgroundColor: '#406cc2',
                        textStyle: {
                            color: "#fff",
                            fontSize: 12
                        },
                        position: function (point) {
                            // 固定在顶部
                            // return [point[0], '0'];
                        },
                        padding: [5, 10],
                        confine: true,
                        formatter: function (params) {
                            var string = '';
                            if (!isNaN(params[0].value)) {
                                string += '昨日涨停股今日表现:' + params[0].value + '%<br/>';
                            }
                            if (!isNaN(params[1].value)) {
                                string += '上证指数今日表现:' + params[1].value + '%<br/>';
                            }
                            return (string == '') ? false : params[0].name + '<br/>' + string;
                        },
                        axisPointer: {
                            lineStyle: {color: '#406cc2'},
                        }
                    },
                    color: ['#FF0000','#3366cc'],
                    grid: {
                        left: 10,
                        right: 30,
                        top: 20,
                        bottom: 0,
                        containLabel: true
                    },
                    dataZoom: [{
                        type: 'slider',
                        show: false
                    }],
                    xAxis: {
                        type: 'category',
                        axisLabel: {
                            interval: function(index,name){//index是x轴的坐标序号，name是坐标值
                                var timeLength=_this.chartData.time.length-1;
                                var interval
                                if(timeLength<=10){
                                    if(index==0){
                                        return true;
                                    }
                                    if(index==timeLength){
                                        return true;
                                    }
                                }else if(timeLength<=30){
                                    interval=Math.ceil(timeLength/2)
                                    if(index==interval*0){
                                        return true;
                                    }
                                    if(index==interval*1){
                                        return true;
                                    }
                                    if(index==timeLength){
                                        return true;
                                    }
                                }else{
                                    interval=Math.ceil(timeLength/4)
                                    if(index==interval*0){
                                        return true;
                                    }
                                    if(index==interval*1){
                                        return true;
                                    }
                                    if(index==interval*2){
                                        return true;
                                    }
                                    if(index==interval*3){
                                        return true;
                                    }
                                    if(index==timeLength){
                                        return true;
                                    }
                                }
                            },
                            textStyle: {fontSize: 13},
                            formatter: null
                        },
                        axisTick:{
                            show:false //是否显示坐标轴刻度
                        },
                        data: _this.chartData.time
                    },
                    yAxis: {
                        type: 'value',
                        scale: true,
                        axisLine: {
                            show: false
                        },
                        axisTick: {
                            show: false
                        },
                        axisLabel: {
                            margin: 2,
                            textStyle: {fontSize: 13},
                            formatter:'{value}%'
                        },
                        splitLine: {
                            show: true,
                            lineStyle: {}
                        },
                        splitNumber: 3,
                    },
                    series: [
                        {
                            name: '自然板家数',
                            type: 'line',
                            smooth: true,
                            showSymbol: false,
                            symbol: 'circle',
                            symbolSize: 3,
                            z: 100,
                            itemStyle: {
                                normal: {
                                    borderColor: 'rgba(62, 106, 197, 0.5)',
                                    borderWidth: 5
                                }
                            },
                            data: _this.chartData.zrztbkzf
                        },
                        {
                            name: '触及涨停',
                            type: 'line',
                            smooth: true,
                            showSymbol: false,
                            symbol: 'circle',
                            symbolSize: 3,
                            z: 100,
                            itemStyle: {
                                normal: {
                                    borderColor: 'rgba(253, 136, 36, 0.5)',
                                    borderWidth: 5
                                }
                            },
                            data: _this.chartData.szzszf
                        }
                    ]
                };
                echart.setOption(option);
            }
        }
    }
</script>


// WEBPACK FOOTER //
// src/pages/home/components/zrztjrbx.vue